const mobileNavigationButton = document.querySelector('#showMobileNav');

const mobileNavWrapper       = document.querySelector('.mobileNavWrapper');
const mobileNavDialog        = document.querySelector('#mobileNavDialog');
const dialogTitle            = document.querySelector('#dialogTitle');
const theLeftNav             = document.querySelector('.leftNav');
const theRightNav            = document.querySelector('.rightNav');

/* Functions to move DOM nodes around */
function moveIntoDialog() {
	dialogTitle.after( theRightNav )
	dialogTitle.after( theLeftNav );
}
function moveOutOfDialog() {
	mobileNavWrapper.after( theRightNav );
	mobileNavWrapper.after( theLeftNav );
}

/* Where do we want DOM nodes given the current screen size? */
let screenWidth = window.matchMedia('(max-width: 1023px)');
if( screenWidth.matches ) { moveIntoDialog(); }
else { moveOutOfDialog(); }

/* Watch for changes and apply as needed */
screenWidth.addEventListener("change", (e) => {
	if( e.matches ) { moveIntoDialog(); }
	else { moveOutOfDialog(); }
});

/**
 * Handles DOM interactions for sub-menu display (this is independent of the mobile nav)
 *
 * @param navigationContainer {string} - A selector string to identify the main menu within which the sub-menus live
 * @param subNavSelector {string} - A selector string to identify any nodes that are sub-navigation elements
 */
function handleSubNavs(
	navigationContainer,
	subNavSelector
) {
	const theMenu = document.querySelector(navigationContainer);
	const subNavs = theMenu.querySelectorAll(subNavSelector);

	// Accessibility enhancements for the dynamic toggling control
	// add ARIA labels to things that need them
		subNavs.forEach(subNav => {
			subNav.setAttribute('aria-haspopup', true);
			subNav.setAttribute('aria-expanded', false);
		});

	// Handle the sub-nav stuff
		subNavs.forEach(subNav => {
			let subNavToggle = subNav.querySelector(':scope > .groupAnchors > .toggleSubmenu');

			// add in a "back" button for each
				let subList = subNav.querySelector(':scope > ul');
				subList.insertAdjacentHTML("afterbegin", `<li class="js-back"><a href="#">Close Pane</a></li>`);

			// listen for clicks on the subNavToggle
				subNavToggle.addEventListener("click", function(e) {
					e.preventDefault();
					let clickedSubNavUl = e.currentTarget;

					// whatever is happening on this subNav, we want to hide all other subNavs UNLESS the other "sub nav" in question is actually a parent of the *current* nav (nested navs are fun)
						subNavs.forEach(thisSubNav => {
							if (! thisSubNav.contains(clickedSubNavUl)) {
								thisSubNav.dataset.submenuStatus = 'closed';
								subNav.setAttribute("aria-expanded", "false");
							}
						});

					// now, do we need to do anything with this particular subNav?
						let subNavIsOpen    = subNav.dataset.submenuStatus == 'open'; // returns true|false
						let newSubNavStatus = !subNavIsOpen; // inverts the value

						subNav.dataset.submenuStatus = newSubNavStatus ? 'open' : 'closed'; // update the data attribute
						subNav.setAttribute("aria-expanded", newSubNavStatus); // update the aria attribute

						// Ok, and does the nav we just closed itself have subNavs, which we ALSO need to close?
						subNav.querySelectorAll(':scope [data-submenu-status="open"]').forEach(another => {
							another.dataset.submenuStatus = "closed";
							another.setAttribute("aria-expanded", false);
						});

					// listen for clicks on the back link
						let backButton = subNav.querySelector(':scope .js-back a');
						backButton.addEventListener('click', function(e){
							e.preventDefault();

							let parent = e.currentTarget.closest('[data-submenu-status]');
							parent.dataset.submenuStatus = 'closed';
							parent.setAttribute("aria-expanded", "false");
						});
				});
		});
}

handleSubNavs('header','[data-submenu-status]');

/* Watch for clicks outside the nav panel, and dismiss all navs as a results */
	function dismissAllNav() {
		const subNavs = document.querySelectorAll('[data-submenu-status]');
		subNavs.forEach(nav => {
			nav.dataset.submenuStatus = "closed";
		});
	}

	// watch for nav dismissals
	const header = document.querySelector('header');

	document.addEventListener('click', function (event) {
		if (
			! header.contains(event.target)
		) {
			dismissAllNav();
		}
	});
